import { FormControl, MenuItem, TextField } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { ChangeEvent, useCallback } from "react";
import { useGetPatientPaymentsInformationQuery } from "src/api/services/paymentInformationApi";

interface Props {
  patientId: number;
  selected: string;
  setSelected: (v: string) => void;
}

const PaymentMethodSelect = ({ setSelected, patientId, selected }: Props) => {
  const { data: paymentMethods = [] } = useGetPatientPaymentsInformationQuery(
    patientId ? patientId : skipToken,
  );

  const handlePaymentMethod = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      setSelected(e.target.value);
    },
    [setSelected],
  );

  return (
    <FormControl fullWidth>
      <TextField
        required
        select
        label="Payment Method"
        value={selected}
        onChange={handlePaymentMethod}
      >
        {paymentMethods.map((pm) => (
          <MenuItem key={pm.id} value={pm.external_id}>
            {pm.card_brand} {`******${pm.last_4_digits}`}
          </MenuItem>
        ))}
      </TextField>
    </FormControl>
  );
};

export default PaymentMethodSelect;
